/**
 * Detects if the application is running inside an iframe
 * @returns true if running in iframe, false otherwise
 */
export function isInIframe(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}
